import { Routes, Route } from "react-router-dom";
import Homescreen from "../homescreen/homescreen";
import Homescreen2 from "../AutoPay/HomePage";
import ReceiptHomescreen2 from "../AutoPay/NewHomePageRecipt";
import Payment from "../payment/payment";
import Success from "../success/success";
import Failed from "../failed/failed";  
import Payscreen from "../sseven/payscreen";
import ManualPayscreen from "../manualPayment/manual";
import Splitpay from "../splitbillpayment/splitpay";
import MessagePage from "../homescreen/MessagePage";


const Routing = () => {
  
  return (
    <Routes>
      <Route exact path={"/"} element={<Homescreen />} />
      <Route exact path={"/all"} element={<Homescreen2 />} />
      <Route exact path={"/receipt"} element={<ReceiptHomescreen2 />} />
      <Route exact path={"/S7"} element={<Payscreen />} />
      <Route exact path={"/MP"} element={<ManualPayscreen />} />
      <Route exact path={"/SP"} element={<Splitpay />} />
      <Route exact path={"/payment"} element={<Payment />} />
      <Route exact path={"/success"} element={<Success />} />
      <Route exact path={"/failed"} element={<Failed />} />
      <Route exact path={"/unavailable"} element={<MessagePage />} />
    </Routes>
  );
};
export default Routing;
